import { Button, SparkleIcon } from '@iheartjane/reefer';

interface WizardButtonProps {
  className?: string;
  onClickStart: () => void;
}

export const WizardButton = ({
  className,
  onClickStart,
}: WizardButtonProps) => {
  return (
    <Button
      className={className}
      data-testid="wizard-button"
      label="Help me choose"
      onClick={onClickStart}
      startIcon={<SparkleIcon size="sm" />}
    />
  );
};
